// extracted by mini-css-extract-plugin
module.exports = {"tab":"paymentsTab_tab___yloH","emptyState":"paymentsTab_emptyState__8Wmrj","img":"paymentsTab_img__sT9zD","transLink":"paymentsTab_transLink__p39Wi"};